const React = require("react");
function IconClose(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: props.fill || "#232323",
    height: props.size || 24,
    size: props.size || 24,
    width: props.size || 24
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.22498 5.2251c-.27064 0-.50805.10449-.70178.29822s-.29822.43114-.29822.70178.10449.50805.29822.70177l5.0732 5.07323-5.0732 5.0732c-.19373.1937-.29822.4312-.29822.7018s.10449.508.29822.7018c.19373.1937.43114.2982.70178.2982.27063 0 .50804-.1045.70177-.2982L12 13.4037l5.0732 5.0732c.1937.1937.4311.2982.7018.2982.2706 0 .508-.1045.7018-.2982.1937-.1938.2982-.4312.2982-.7018s-.1045-.5081-.2982-.7018l-5.0733-5.0732 5.0733-5.07323c.1937-.19372.2982-.43113.2982-.70177s-.1045-.50805-.2982-.70178c-.1938-.19373-.4312-.29822-.7018-.29822-.2707 0-.5081.10449-.7018.29822L12 10.5965 6.92675 5.52332c-.19373-.19373-.43114-.29822-.70177-.29822"
  }));
}
module.exports = IconClose;